import standardAPI from '@/api/standard_items';

const state = {
  price_categories: [],
  price_categories_status: '',
  price_categories_MetaData: {},
  price_categories_page: 1,
  price_categories_perPage: 10,
};

const responseUrl = '/price-types';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_price_categories ({ commit }, getOptions) {
    commit('PRICE_CATEGORIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('PRICE_CATEGORIES_SUCCESS', response);
            commit('PRICE_CATEGORIES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('PRICE_CATEGORIES_READY');
            reject(response);
          } else {
            commit('PRICE_CATEGORIES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_price_category ({ commit, dispatch }, itemData) {
    commit('PRICE_CATEGORIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('PRICE_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  edit_price_category ({ commit, dispatch }, itemData) {
    commit('PRICE_CATEGORIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        // console.log(response)
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('PRICE_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  remove_price_category ({ commit, dispatch }, itemData) {
    commit('PRICE_CATEGORIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('PRICE_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_price_category ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          // console.log(pageOptions)
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  upload_image ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData: itemData,
      url: '/upload-file/temp',
    };
    return new Promise((resolve, reject) => {
      standardAPI.upload_file(preparedData, (response) => {
        if (response.id) {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.price_categories_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.price_categories_perPage = max;
  },
  PRICE_CATEGORIES_READY: (state) => {
    state.price_categories_status = 'ready';
  },
  PRICE_CATEGORIES_REQUEST: (state) => {
    state.price_categories_status = 'loading';
  },
  PRICE_CATEGORIES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.price_categories_MetaData.meta = response.meta;
      state.price_categories_MetaData.links = response.links;
    }
    state.price_categories = response.data;
    state.price_categories_status = 'success';
  },
  PRICE_CATEGORIES_ERROR: (state) => {
    state.price_categories_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
